import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { ICoreAppOnboardingState } from "@/apps/core-app-onboarding/types/ICoreAppOnboardingState";

export const localStoragePersonUuidKey = "personUuid";
export const localStorageSessionIdKey = "creditLineApplicationId";

export default {
  namespaced: true,
  state: {
    foo: "",
  } as ICoreAppOnboardingState,
  mutations,
  actions,
  getters,
};
